import ObjectBuilderInterface from "@/modules/api/object-builder.interface";

import DistributionCenter from "./distribution-center.model";

export default class DistributionCenterFactory
  implements ObjectBuilderInterface<DistributionCenter> {
  public buildFromJSON(data: { [key: string]: any }): DistributionCenter {
    const value = new DistributionCenter(
      data.id,
      data.name,
      data.code,
      data.email,
      data.active,
      data.boxParametersRequired,
      data.sendNotificationCopy,
      data.serialNumber
    );

    value.isNew = false;

    return value;
  }
}
